import { render } from "./releases-timeline.vue?vue&type=template&id=7eaaf88f&scoped=true"
import script from "./releases-timeline.vue?vue&type=script&lang=js"
export * from "./releases-timeline.vue?vue&type=script&lang=js"

import "./releases-timeline.vue?vue&type=style&index=0&id=7eaaf88f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eaaf88f"]])

export default __exports__